export const iconFontAwesomeSportsFitnessHockeyPuck = (
	<i className="fa-solid fa-hockey-puck"></i>
);
